import React, { useEffect, useState } from 'react';
import {
  useAddRegionSnacksMutation,
  useAddSnacksMutation,
  useGetRegionSnacksQuery,
  useGetSnacksQuery,
} from '../teaAndSnacksApiSlice';
import toast from 'react-hot-toast';
import { IconButton, Input, InputAdornment, Stack } from '@mui/material';
import { getDDMMYYYY } from '../../../utils/dateTimeFormats';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';

const EditSnackForm = ({ isEditable = false,locationData,currentDate }) => {
  // const location = localStorage.getItem('location'); 
  const [textValue1, setTextValue1] = useState('');
  const [textValue2, setTextValue2] = useState('');
  const [isEditing1, setIsEditing1] = useState(false);
  const [isEditing2, setIsEditing2] = useState(false);
  // const currentDate = new Date(new Date().toDateString()).getTime();
console.log("locationData",locationData,currentDate);


  const {
    data: snacksRegionData,
    isLoading: snacksRegionLoading,
    isError: snacksRegionError,
    refetch: snacksRegionRefetch
  } = useGetRegionSnacksQuery(
      { date: currentDate, region: locationData },
      {
        skip: !locationData ,
      }
    );
  const { data: snacksData, isLoading: snacksLoading, isError: snacksError } = useGetSnacksQuery();
  const [addSnackData] = useAddSnacksMutation();
  const [addRegionSnackData] = useAddRegionSnacksMutation();

  useEffect(() => {
    if (snacksData) {
     snacksRegionRefetch()
    }
  }, [snacksData]);

  const handleEdit = async (key, value) => {
    const dateToday = new Date(new Date().toDateString()).getTime();

    if (locationData == 'Ahmedabad') {
      if (key == 'snack') {
        if (value.trim() == '') {
          toast.error('Snack cannot be empty');
          return;
        }
        await toast.promise(addSnackData({ date: dateToday, snack: value, healthy: textValue2 }).unwrap(), {
          loading: 'Updating...',
          success: 'Item Updated',
          error: (err) => err.data?.message || 'Error Updating Item. Please try again.',
        });
        setIsEditing1(!isEditing1);
      } else {
        if (value.trim() == '') {
          toast.error('Healthy cannot be empty');
          return;
        }
        await toast.promise(addSnackData({ date: dateToday, snack: textValue1, healthy: value }).unwrap(), {
          loading: 'Updating...',
          success: 'Item Updated',
          error: (err) => err.data?.message || 'Error Updating Item. Please try again..',
        });
        setIsEditing2(!isEditing2);
      }
    } else {
      if (value.trim() == '') {
        toast.error('Snack cannot be empty');
        return;
      }
      let params = {
        date: dateToday,
        region: locationData,
        snack: value,
      };
      await toast.promise(addRegionSnackData(params).unwrap(), {
        loading: 'Updating...',
        success: 'Item Updated',
        error: (err) => err.data?.message || 'Error Updating Item. Please try again.',
      });
      setIsEditing1(!isEditing1);
    }
  };

  // Fetch Today's Snack
  useEffect(() => {
    if (locationData == 'Ahmedabad') {
      if (!snacksLoading && !snacksError && snacksData?.length > 0) {
        setTextValue1(snacksData[0].snack);
        setTextValue2(snacksData[0].healthy);
      }
    } else {
      if (!snacksRegionLoading && !snacksRegionError && snacksRegionData?.data) {
        console.log('Snacks Data', snacksRegionData.data);
        setTextValue1(snacksRegionData?.data?.snack);
      }
    }
  }, [snacksData, snacksRegionData,snacksError,snacksLoading,snacksRegionError,snacksRegionLoading]);

  
  return (
    <Stack direction="column" sx={{ width: 260, padding: 3 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <p style={{}}>Today's Snack</p>
        {snacksData?.length > 0 && snacksData[0]?.date && (
          <p style={{ color: 'GrayText' }}>{getDDMMYYYY(snacksData[0].date)}</p>
        )}
      </div>
      <div className="border m-0 p-2" style={{ borderBottom: 1, padding: '8px' }}>
        <Input
          fullWidth
          placeholder="Enter Snack"
          value={textValue1}
          onChange={(e) => setTextValue1(e.target.value)}
          disabled={!isEditing1 || !isEditable}
          endAdornment={
            <InputAdornment position="end">
              <IconButton>
                {isEditing1 ? (
                  <CheckIcon
                    onClick={() => {
                      handleEdit('snack', textValue1);
                    }}
                  />
                ) : (
                  isEditable && <EditIcon onClick={() => setIsEditing1(!isEditing1)} />
                )}
              </IconButton>
            </InputAdornment>
          }
        />
        {locationData == 'Ahmedabad' && (
          <Input
            fullWidth
            placeholder="Enter Healthy"
            value={textValue2}
            onChange={(e) => setTextValue2(e.target.value)}
            disabled={!isEditing2}
            endAdornment={
              <InputAdornment position="end">
                <IconButton>
                  {isEditing2 ? (
                    <CheckIcon
                      onClick={() => {
                        handleEdit('healthy', textValue2);
                      }}
                    />
                  ) : (
                    <EditIcon onClick={() => setIsEditing2(!isEditing2)} />
                  )}
                </IconButton>
              </InputAdornment>
            }
          />
        )}
      </div>
    </Stack>
  );
};

export default EditSnackForm;
